/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-useless-fragment */
import { useForm } from "react-hook-form";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Form,
  FormField,
  FormItem,
  FormControl,
  DatePicker,
} from "@repo/ui";
import { createRef, useEffect } from "react";
import { GridColumn } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { Label } from "ui/label";
import Loader from "ui/page-loader";
import { useGetReports } from "services/reports";
import { FormDropdown } from "ui/combo-box";
import { getLocalISODateString } from "utils/date-utils";

export default function ServiceCallsReports({
  customersList,
  cashCentersList,
}) {
  const _exporter = createRef();

  const {
    mutate: getReports,
    data: reportsRes,
    isPending: gettingReports,
    reset: resetReports,
  } = useGetReports();

  const form = useForm({
    defaultValues: {
      cashCenterId: "",
      customerId: "",
      toDate: new Date(),
      fromDate: new Date(),
    },
  });

  const generalProps = { errors: form.formState.errors, control: form.control };
  const verificationRules = {
    fromDate: { required: "Please Select Date" },
    toDate: { required: "Please select Date" },
  };

  const onSubmit = (data) => {
    getReports({
      customerId: data.customerId,
      cashCenterId: data.cashCenterId,
      fromDate: getLocalISODateString(data.fromDate),
      toDate: getLocalISODateString(data.toDate),
    });
  };
  const excelExport = () => {
    if (_exporter.current) {
      _exporter.current.save();
      resetReports();
    }
  };

  useEffect(() => {
    if (reportsRes) {
      excelExport();
    }
  }, [reportsRes]);

  return (
    <>
      {gettingReports ? <Loader /> : <></>}

      <Card className="form-card shadow-lg mx-0 mt-6">
        <CardHeader>
          <CardTitle>Service Calls</CardTitle>
        </CardHeader>
        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(onSubmit)}
            className="space-y-8 custom-form-v2"
          >
            <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
              {/* <FormInput
                  {...generalProps}
                  isRequired={true}
                  name={"customerId"}
                  label={"Customer Id"}
                  rules={verificationRules.customerId}
                /> */}
              <div className="form-row-d-50">
                <FormDropdown
                  {...generalProps}
                  label="Customer"
                  name="customerId"
                  // isRequired
                  data={customersList || []}
                  text="name"
                  id="customerId"
                  placeholder="Select Customer"
                  // rules={verificationRules.customerId}
                />
                <FormDropdown
                  {...generalProps}
                  label="Cash Center"
                  name="cashCenterId"
                  // isRequired
                  data={cashCentersList || []}
                  text="name"
                  id="cashCenterId"
                  placeholder="Select Cash Center"
                  // rules={verificationRules.cashCenterId}
                />

                <FormField
                  control={form.control}
                  name="fromDate"
                  rules={verificationRules.fromDate}
                  render={({ field }) => (
                    <FormItem>
                      <Label label="From Date" isRequired />
                      <FormControl>
                        <div
                          className={
                            form.formState?.errors?.fromDate
                              ? "form-date-picker border-red-500 mr-[36px]"
                              : "form-date-picker border-secondary mr-[36px]"
                          }
                        >
                          <DatePicker
                            required
                            selectedDate={field.value}
                            placeholder="Select Date"
                            mode="single"
                            variant="secondary"
                            onSelectDate={(e) => {
                              if (e) {
                                if (form.getValues("toDate")) {
                                  form.setValue("toDate", e);
                                }
                                field.onChange(e);
                              } else {
                                field.onChange(null);
                              }
                            }}
                          />
                          {form.formState?.errors?.fromDate ? (
                            <p className="text-destructive text-xs">
                              Please Select Date
                            </p>
                          ) : (
                            <></>
                          )}
                        </div>
                      </FormControl>
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="toDate"
                  rules={verificationRules.toDate}
                  render={({ field }) => (
                    <FormItem>
                      <Label label="To Date" isRequired />
                      <FormControl>
                        <div
                          className={
                            form.formState?.errors?.toDate
                              ? "form-date-picker border-red-500 mr-[36px]"
                              : "form-date-picker border-secondary mr-[36px]"
                          }
                        >
                          <DatePicker
                            required
                            selectedDate={field.value}
                            placeholder="Select Date"
                            onSelectDate={(e) => {
                              if (e) {
                                form.setValue("toDate", e);
                                field.onChange(e);
                              } else {
                                field.onChange(null);
                              }
                            }}
                          />
                          {form.formState?.errors?.toDate ? (
                            <p className="text-destructive text-xs">
                              Please Select Date
                            </p>
                          ) : (
                            <></>
                          )}
                        </div>
                      </FormControl>
                    </FormItem>
                  )}
                />
              </div>
              <div className="flex flex-row justify-end w-full gap-2 mr-[36px]">
                <Button variant="secondary" type="submit">
                  Get Report
                </Button>
              </div>
              <ExcelExport
                data={reportsRes?.data || []}
                fileName="Reports.xlsx"
                ref={_exporter}
              >
                <GridColumn title="TG Reference No" field="caseNo" />
                <GridColumn title="Task No" field="taskNo" />
                <GridColumn title="Bank Reference" field="bankReference" />
                <GridColumn title="Created" field="created" />
                <GridColumn title="Opened By" field="openedBy" />
                <GridColumn title="Account" field="account" />
                <GridColumn title="Asset Id" field="assetId" />
                <GridColumn title="Location" field="location" />
                <GridColumn title="Region" field="region" />
                <GridColumn title="City" field="city" />
                <GridColumn title="Activity Type" field="activityType" />
                <GridColumn title="Category" field="category" />
                <GridColumn title="Sub Category" field="subCategory" />
                <GridColumn title="Is Chargeable" field="isChargeable" />
                <GridColumn
                  title="Vault Access Required"
                  field="vaultAccessRequired"
                />
                <GridColumn title="Description" field="description" />
                <GridColumn title="Assignment Group" field="assignmentGroup" />
                <GridColumn title="Dispatcher" field="dispatcher" />
                <GridColumn title="Primary Assignee" field="primaryAssignee" />
                <GridColumn title="TGID1" field="tgiD1" />
                <GridColumn title="Cencon ID1" field="cenconId1" />
                <GridColumn
                  title="Secondary Assignee"
                  field="secondaryAssignee"
                />
                <GridColumn title="TGID2" field="tgiD2" />
                <GridColumn title="Cencon ID2" field="cenconId2" />
                <GridColumn title="Assigned Date" field="assignedDate" />
                <GridColumn title="Accepted Date" field="acceptedDate" />
                <GridColumn title="Start Trip" field="startTrip" />
                <GridColumn title="End Trip" field="tripEnd" />
                <GridColumn title="Actual Start Date" field="actualStartDate" />
                <GridColumn title="Actual End Date" field="actualEndDate" />
                <GridColumn title="Closed" field="closed" />
                <GridColumn title="Closed By" field="closedBy" />
                <GridColumn title="IT Name" field="itName" />
                <GridColumn title="Task Status" field="taskStatus" />
                <GridColumn title="Ticket Status" field="ticketStatus" />
                <GridColumn title="Route No" field="routeName" />
                <GridColumn title="Resolution Notes" field="resolutionNotes" />
                <GridColumn title="Priority" field="priority" />
              </ExcelExport>
            </CardContent>
          </form>
        </Form>
      </Card>
    </>
  );
}
